__turbopack_context__.v({
  "STrackingPixel": "WPeWha_STrackingPixel",
});
